import { Component, ElementRef, EventEmitter, HostListener, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { PopupConfirmacionComponent } from 'src/app/base/components/popup-confirmacion/popup-confirmacion.component';
import { GlobalVariable } from 'src/app/global';
import { BaseComponent } from 'src/app/models/base-component';
import { CertificadosService } from '../../services/certificados/certificados.service';

declare const PDFDocument:any;
declare const blobStream:any;

/* Certificados de jugadores de un campeonato. Una plantilla es un fondo opcional y una lista de elementos
   posicionados en puntos PDF (origen arriba a la izquierda): texto (con variables {jugador}, {equipo}...),
   imagen (logos, foto o una imagen subida como una firma), linea y marco. El diseño se edita en un lienzo HTML
   con la hoja a escala (arrastrar para mover, la esquina para redimensionar, flechas del teclado para ajustar),
   y la pestaña PDF dibuja con pdfkit lo mismo que despues se imprime, una pagina por jugador. Ademas de las
   fuentes estandar de pdfkit se pueden subir fuentes TTF/OTF de la empresa. */
@Component({
    selector: 'app-certificados-campeonato',
    templateUrl: './certificados-campeonato.component.html',
    styleUrls: ['./certificados-campeonato.component.css'],
    standalone: false
})
export class CertificadosCampeonatoComponent extends BaseComponent implements OnInit, OnDestroy {

  campeonato:any;
  @Output() alTerminar:EventEmitter<any> = new EventEmitter<any>();

  pestana:string="diseno";
  plantillas:any[]=[];
  plantilla:any=null;
  elemento:any=null;
  vista_previa:any={ pdf:null, generando:false, mensaje:null };
  temporizador_vista_previa:any;
  cache_imagenes:Map<string,Promise<any>>=new Map();

  vista:string="lienzo";
  panel_oculto:boolean=false;
  ancho_lienzo:number=0;
  alto_ventana:number=window.innerHeight;
  observador_lienzo:ResizeObserver;
  arrastre:any=null;
  guias:any={ vertical:false, horizontal:false };
  fuentes_personalizadas:any[]=[];
  cache_fuentes:Map<string,Promise<ArrayBuffer>>=new Map();
  nueva_fuente:any={ nombre:"", archivo:null, extension:".ttf" };

  //el ancho del lienzo sigue al de su columna: la escala se recalcula al cambiar el tamaño de la ventana
  @ViewChild('contenedor_lienzo') set contenedorLienzo(contenedor:ElementRef){
    if(this.observador_lienzo){
      this.observador_lienzo.disconnect();
      this.observador_lienzo=null;
    }
    if(contenedor){
      this.observador_lienzo=new ResizeObserver((entradas) => {
        this.zone.run(() => this.ancho_lienzo=entradas[0].contentRect.width);
      });
      this.observador_lienzo.observe(contenedor.nativeElement);
    }
  }

  jugadores_equipo:any[]=[];
  disciplinas:any[]=[];
  categorias:any[]=[];
  equipos:any[]=[];
  filtro:any={ tipo:"TODOS", id_disciplina:null, id_categoria:null, id_equipo:null, texto:"" };
  generacion:any={ id_plantilla:null };

  tipos_certificado=[
    { codigo:"PARTICIPACION", nombre:"Participación", titulo:"CERTIFICADO DE PARTICIPACIÓN",
      cuerpo:"Por su destacada participación en el campeonato {campeonato}, categoría {categoria}, disciplina {disciplina}, representando al equipo {equipo}." },
    { codigo:"CAMPEON", nombre:"Campeón", titulo:"CERTIFICADO DE CAMPEÓN",
      cuerpo:"Por obtener el PRIMER LUGAR con el equipo {equipo} en el campeonato {campeonato}, categoría {categoria}, disciplina {disciplina}." },
    { codigo:"SUBCAMPEON", nombre:"Subcampeón", titulo:"CERTIFICADO DE SUBCAMPEÓN",
      cuerpo:"Por obtener el SEGUNDO LUGAR con el equipo {equipo} en el campeonato {campeonato}, categoría {categoria}, disciplina {disciplina}." },
    { codigo:"TERCER_LUGAR", nombre:"Tercer lugar", titulo:"CERTIFICADO DE TERCER LUGAR",
      cuerpo:"Por obtener el TERCER LUGAR con el equipo {equipo} en el campeonato {campeonato}, categoría {categoria}, disciplina {disciplina}." },
    { codigo:"DESTACADO", nombre:"Reconocimiento", titulo:"CERTIFICADO DE RECONOCIMIENTO",
      cuerpo:"En reconocimiento a su desempeño sobresaliente con el equipo {equipo} en el campeonato {campeonato}, categoría {categoria}." }
  ];
  tamanos_papel:any={ CARTA:[612,792], OFICIO:[612,936], A4:[595.28,841.89] };
  fuentes=["Helvetica","Helvetica-Bold","Helvetica-Oblique","Helvetica-BoldOblique","Times-Roman","Times-Bold",
           "Times-Italic","Times-BoldItalic","Courier","Courier-Bold"];
  variables=[
    { codigo:"{jugador}", nombre:"Nombre del jugador" },
    { codigo:"{ci}", nombre:"CI del jugador" },
    { codigo:"{codigo_jugador}", nombre:"Código del jugador" },
    { codigo:"{posicion}", nombre:"Posición" },
    { codigo:"{cargo}", nombre:"Cargo (Jugador, Entrenador, Delegado...)" },
    { codigo:"{equipo}", nombre:"Equipo" },
    { codigo:"{categoria}", nombre:"Categoría" },
    { codigo:"{disciplina}", nombre:"Disciplina" },
    { codigo:"{campeonato}", nombre:"Campeonato" },
    { codigo:"{empresa}", nombre:"Empresa / Liga" },
    { codigo:"{fecha_inicio}", nombre:"Inicio del campeonato" },
    { codigo:"{fecha_fin}", nombre:"Fin del campeonato" },
    { codigo:"{fecha_emision}", nombre:"Fecha de emisión (dd/mm/aaaa)" },
    { codigo:"{fecha_emision_literal}", nombre:"Fecha de emisión (literal)" }
  ];
  origenes_imagen=[
    { codigo:"logo_campeonato", nombre:"Logo del campeonato" },
    { codigo:"logo_equipo", nombre:"Logo del equipo" },
    { codigo:"foto_jugador", nombre:"Foto del jugador" },
    { codigo:"archivo", nombre:"Imagen subida (firma, sello...)" }
  ];
  meses=["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];

  constructor(
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService:NgbModal,
    public certificadosService:CertificadosService,
    private zone:NgZone,
    private toastr:ToastrService) {
      super(persistenciaService,modalService,generalService,usuarioService);
  }

  async ngOnInit(){
    this.blockUI.start();
    try{
      let plantillas:any=await this.certificadosService.obtenerPlantillasCampeonato(this.campeonato.id).toPromise();
      this.plantillas=plantillas.map((p) => this.normalizarPlantilla(p));
      let jugadores_equipo:any=await this.certificadosService.obtenerJugadoresCampeonato(this.campeonato.id).toPromise();
      this.jugadores_equipo=Array.isArray(jugadores_equipo)?jugadores_equipo:[];
      this.jugadores_equipo.forEach((je) => je.seleccionado=true);
      this.armarFiltros();
      this.cargarDestinatariosManuales();
      //sin fuentes (o con un servidor sin esta ruta) se sigue con las estandar
      let fuentes:any=await this.certificadosService.obtenerFuentesEmpresa(this.usuario.id_empresa).toPromise().catch(() => []);
      this.fuentes_personalizadas=Array.isArray(fuentes)?fuentes:[];
      this.fuentes_personalizadas.forEach((fuente) => this.cargarFuenteLienzo(fuente));
      if(this.plantillas.length>0){
        this.seleccionarPlantilla(this.plantillas[0]);
        this.generacion.id_plantilla=this.plantillas[0].id;
      }
    }finally{
      this.blockUI.stop();
    }
  }

  ngOnDestroy(){
    clearTimeout(this.temporizador_vista_previa);
    if(this.observador_lienzo){
      this.observador_lienzo.disconnect();
    }
    this.terminarArrastre();
  }

  normalizarPlantilla(plantilla){
    if(typeof plantilla.elementos=="string"){
      plantilla.elementos=JSON.parse(plantilla.elementos);
    }
    plantilla.elementos=plantilla.elementos || [];
    return plantilla;
  }

  /* ---------- Diseño ---------- */

  medidasPagina(plantilla){
    let medida=this.tamanos_papel[plantilla.tamano_papel] || this.tamanos_papel.CARTA;
    return plantilla.orientacion=="HORIZONTAL"?[medida[1],medida[0]]:[medida[0],medida[1]];
  }

  tipoCertificado(codigo){
    return this.tipos_certificado.filter((t) => t.codigo==codigo)[0] || this.tipos_certificado[0];
  }

  //diseño de arranque centrado en la hoja, sirve tanto horizontal como vertical
  elementosPorDefecto(plantilla){
    let [W,H]=this.medidasPagina(plantilla);
    let tipo=this.tipoCertificado(plantilla.tipo);
    let color="#1f3864";
    return [
      { tipo:"marco", x:20, y:20, ancho:W-40, alto:H-40, grosor:4, color:color },
      { tipo:"marco", x:30, y:30, ancho:W-60, alto:H-60, grosor:1, color:color },
      { tipo:"imagen", origen:"logo_campeonato", x:W/2-45, y:45, ancho:90, alto:90 },
      { tipo:"texto", contenido:tipo.titulo, x:60, y:150, ancho:W-120, alto:40, fuente:"Times-Bold", tamano:30, color:color, alineacion:"center" },
      { tipo:"texto", contenido:"Otorgado a:", x:60, y:205, ancho:W-120, alto:20, fuente:"Times-Italic", tamano:16, color:"#444444", alineacion:"center" },
      { tipo:"texto", contenido:"{jugador}", x:60, y:235, ancho:W-120, alto:45, fuente:"Times-BoldItalic", tamano:32, color:"#000000", alineacion:"center", mayusculas:true },
      { tipo:"linea", x:W/2-220, y:285, ancho:440, grosor:1, color:color },
      { tipo:"texto", contenido:tipo.cuerpo, x:90, y:305, ancho:W-180, alto:80, fuente:"Times-Roman", tamano:15, color:"#222222", alineacion:"center" },
      { tipo:"texto", contenido:"{fecha_emision_literal}", x:60, y:H-170, ancho:W-120, alto:18, fuente:"Times-Italic", tamano:12, color:"#444444", alineacion:"center" },
      { tipo:"linea", x:W/2-100, y:H-100, ancho:200, grosor:1, color:"#000000" },
      { tipo:"texto", contenido:"ORGANIZACIÓN", x:W/2-100, y:H-95, ancho:200, alto:14, fuente:"Helvetica-Bold", tamano:10, color:"#000000", alineacion:"center" }
    ];
  }

  crearPlantilla(){
    let plantilla:any={ id_campeonato:this.campeonato.id, id_empresa:this.usuario.id_empresa, nombre:"",
                        tipo:"PARTICIPACION", tamano_papel:"CARTA", orientacion:"HORIZONTAL", fondo:null, elementos:[] };
    plantilla.nombre=this.tipoCertificado(plantilla.tipo).nombre;
    plantilla.elementos=this.elementosPorDefecto(plantilla);
    this.plantilla=plantilla;
    this.elemento=null;
    this.programarVistaPrevia(0);
  }

  //se edita una copia: cerrar o cambiar de plantilla sin guardar no deja cambios a medias
  seleccionarPlantilla(plantilla){
    this.plantilla=JSON.parse(JSON.stringify(plantilla));
    this.elemento=null;
    this.programarVistaPrevia(0);
  }

  restablecerDiseno(){
    this.plantilla.elementos=this.elementosPorDefecto(this.plantilla);
    this.elemento=null;
    this.programarVistaPrevia(0);
  }

  agregarElemento(tipo){
    let [W]=this.medidasPagina(this.plantilla);
    let elemento:any;
    if(tipo=="texto"){
      elemento={ tipo:"texto", contenido:"Texto", x:60, y:100, ancho:W-120, alto:20, fuente:"Helvetica", tamano:14, color:"#000000", alineacion:"center" };
    }else if(tipo=="imagen"){
      elemento={ tipo:"imagen", origen:"archivo", imagen:null, x:60, y:100, ancho:120, alto:60 };
    }else if(tipo=="linea"){
      elemento={ tipo:"linea", x:W/2-100, y:100, ancho:200, grosor:1, color:"#000000" };
    }else{
      elemento={ tipo:"marco", x:40, y:40, ancho:200, alto:100, grosor:1, color:"#000000" };
    }
    this.plantilla.elementos.push(elemento);
    this.elemento=elemento;
    this.programarVistaPrevia();
  }

  eliminarElemento(elemento){
    this.plantilla.elementos.splice(this.plantilla.elementos.indexOf(elemento),1);
    if(this.elemento===elemento){
      this.elemento=null;
    }
    this.programarVistaPrevia();
  }

  //el orden de la lista es el orden de dibujo: lo de abajo queda encima
  moverElemento(elemento,direccion){
    let lista=this.plantilla.elementos,indice=lista.indexOf(elemento),destino=indice+direccion;
    if(destino<0 || destino>=lista.length){
      return;
    }
    lista.splice(indice,1);
    lista.splice(destino,0,elemento);
    this.programarVistaPrevia();
  }

  insertarVariable(variable){
    this.elemento.contenido=(this.elemento.contenido?this.elemento.contenido+" ":"")+variable;
    this.programarVistaPrevia();
  }

  descripcionElemento(elemento){
    if(elemento.tipo=="texto"){
      return elemento.contenido;
    }else if(elemento.tipo=="imagen"){
      let origen=this.origenes_imagen.filter((o) => o.codigo==elemento.origen)[0];
      return "Imagen: "+(origen?origen.nombre:"");
    }
    return elemento.tipo=="linea"?"Línea":"Marco";
  }

  cambiarTipoPlantilla(){
    //si el nombre era el de un tipo, sigue al tipo nuevo; si el usuario lo escribio, se respeta
    let es_nombre_tipo=this.tipos_certificado.filter((t) => t.nombre==this.plantilla.nombre).length>0;
    if(!this.plantilla.nombre || es_nombre_tipo){
      this.plantilla.nombre=this.tipoCertificado(this.plantilla.tipo).nombre;
    }
    this.programarVistaPrevia();
  }

  leerArchivoImagen(evento,asignar){
    let archivo=evento.target.files[0];
    if(!archivo){
      return;
    }
    let lector=new FileReader();
    lector.onloadend=() => {
      asignar(lector.result);
      this.programarVistaPrevia(0);
    };
    lector.readAsDataURL(archivo);
  }

  subirFondo(evento){
    this.leerArchivoImagen(evento,(base64) => this.plantilla.fondo=base64);
  }

  quitarFondo(){
    this.plantilla.fondo=null;
    this.programarVistaPrevia(0);
  }

  subirImagenElemento(evento){
    let elemento=this.elemento;
    this.leerArchivoImagen(evento,(base64) => elemento.imagen=base64);
  }

  validarPlantilla(){
    if(!this.plantilla.nombre){
      this.toastr.error("Debe especificar el nombre de la plantilla!");
      return false;
    }
    if(this.plantilla.elementos.length==0){
      this.toastr.error("La plantilla no tiene elementos!");
      return false;
    }
    return true;
  }

  async guardarPlantilla(){
    if(!this.validarPlantilla()){
      return;
    }
    this.blockUI.start();
    try{
      let plantilla=this.plantilla;
      plantilla.id_empresa=this.usuario.id_empresa;
      if(plantilla.id){
        let res:any=await this.certificadosService.actualizarPlantilla(plantilla).toPromise();
        if(res.tiene_error){
          this.toastr.error(res.mensaje);
          return;
        }
        plantilla.fondo=res.fondo;
        plantilla.elementos=res.elementos;
        let indice=this.plantillas.findIndex((p) => p.id==plantilla.id);
        this.plantillas[indice]=JSON.parse(JSON.stringify(plantilla));
        this.toastr.success(res.mensaje);
      }else{
        let res:any=await this.certificadosService.guardarPlantilla(plantilla).toPromise();
        if(res.tiene_error){
          this.toastr.error(res.mensaje);
          return;
        }
        let guardada=this.normalizarPlantilla(res.plantilla);
        this.plantillas.push(guardada);
        this.plantilla=JSON.parse(JSON.stringify(guardada));
        if(!this.generacion.id_plantilla){
          this.generacion.id_plantilla=guardada.id;
        }
        this.toastr.success(res.mensaje);
      }
      this.elemento=null;
    }finally{
      this.blockUI.stop();
    }
  }

  abrirPopupConfirmacionEliminacion(plantilla){
    let popup=this.modalService.open(PopupConfirmacionComponent);
    popup.componentInstance.message="¿Esta seguro de eliminar la plantilla "+plantilla.nombre+"?";
    popup.componentInstance.data=plantilla;
    popup.componentInstance.onConfirm.subscribe(($e) => {
      if($e.confirm){
        this.eliminarPlantilla($e.data);
      }
      popup.close();
    });
  }

  eliminarPlantilla(plantilla){
    this.blockUI.start();
    this.certificadosService.eliminarPlantilla(plantilla).subscribe((res:any) => {
      this.blockUI.stop();
      if(res.tiene_error){
        this.toastr.error(res.mensaje);
        return;
      }
      this.plantillas=this.plantillas.filter((p) => p.id!=plantilla.id);
      if(this.plantilla && this.plantilla.id==plantilla.id){
        this.plantilla=null;
        this.elemento=null;
      }
      if(this.generacion.id_plantilla==plantilla.id){
        this.generacion.id_plantilla=this.plantillas.length>0?this.plantillas[0].id:null;
      }
      this.toastr.success(res.mensaje);
    });
  }

  /* ---------- Exportar / importar ---------- */

  /* El archivo lleva todo lo necesario para usar la plantilla en otro campeonato, otra empresa u otra
     instalacion: el fondo y las imagenes subidas (firmas, sellos) van en base64, y tambien las fuentes
     personalizadas que usan sus textos. Los logos del campeonato y del equipo y la foto del jugador no
     se incluyen: se toman de los datos de donde se genere. */
  async exportarPlantilla(){
    if(!this.plantilla){
      return;
    }
    this.blockUI.start();
    try{
      let plantilla=JSON.parse(JSON.stringify(this.plantilla));
      plantilla.fondo=await this.archivoComoDataUrl(plantilla.fondo);
      for(let elemento of plantilla.elementos){
        if(elemento.tipo=="imagen" && elemento.origen=="archivo"){
          elemento.imagen=await this.archivoComoDataUrl(elemento.imagen);
        }
      }
      let usadas=new Set(plantilla.elementos.filter((e) => e.tipo=="texto" && e.fuente && !this.esFuenteEstandar(e.fuente)).map((e) => e.fuente));
      let fuentes=[];
      for(let fuente of this.fuentes_personalizadas.filter((f) => usadas.has(f.nombre))){
        fuentes.push({ nombre:fuente.nombre, extension:/\.otf$/i.test(fuente.ruta)?".otf":".ttf",
                       archivo:await this.archivoComoDataUrl(fuente.ruta) });
      }
      let exportacion={
        formato:"snapquick-plantilla-certificado",
        version:1,
        exportado:new Date().toISOString(),
        plantilla:{ nombre:plantilla.nombre, tipo:plantilla.tipo, tamano_papel:plantilla.tamano_papel,
                    orientacion:plantilla.orientacion, fondo:plantilla.fondo, elementos:plantilla.elementos },
        fuentes:fuentes
      };
      let blob=new Blob([JSON.stringify(exportacion)],{ type:"application/json" });
      let enlace=document.createElement("a");
      enlace.href=URL.createObjectURL(blob);
      enlace.download="certificado-"+(plantilla.nombre || "plantilla").replace(/[^A-Za-z0-9áéíóúñÁÉÍÓÚÑ_-]+/g,"-")+".json";
      document.body.appendChild(enlace);
      enlace.click();
      document.body.removeChild(enlace);
      setTimeout(() => URL.revokeObjectURL(enlace.href),1000);
    }catch(error){
      console.error(error);
      this.toastr.error("No se pudo exportar la plantilla: alguna imagen o fuente no se pudo descargar.");
    }finally{
      this.blockUI.stop();
    }
  }

  //una ruta del servidor se descarga entera (sin achicar) para que la plantilla importada no pierda calidad
  async archivoComoDataUrl(ruta){
    if(!ruta || ruta.indexOf("data:")==0){
      return ruta || null;
    }
    let respuesta=await fetch(this.rest_server+ruta);
    if(!respuesta.ok){
      throw new Error("No se pudo descargar "+ruta);
    }
    let blob=await respuesta.blob();
    return new Promise((resolver,rechazar) => {
      let lector=new FileReader();
      lector.onloadend=() => resolver(lector.result);
      lector.onerror=rechazar;
      lector.readAsDataURL(blob);
    });
  }

  /* La plantilla importada se abre en el diseñador como nueva (sin guardar) para revisarla: al guardarla,
     el fondo y las imagenes en base64 se escriben como archivos de esta empresa. Las fuentes que trae y
     esta empresa no tiene se suben al importar, porque el lienzo y la vista previa las necesitan; si ya
     hay una con el mismo nombre se usa la que ya existe. */
  importarPlantilla(evento){
    let archivo=evento.target.files[0];
    evento.target.value="";
    if(!archivo){
      return;
    }
    let lector=new FileReader();
    lector.onloadend=async () => {
      let datos:any;
      try{
        datos=JSON.parse(lector.result as string);
      }catch(error){
        this.toastr.error("El archivo no es una plantilla de certificado válida!");
        return;
      }
      if(!datos || datos.formato!="snapquick-plantilla-certificado" || !datos.plantilla || !Array.isArray(datos.plantilla.elementos)){
        this.toastr.error("El archivo no es una plantilla de certificado válida!");
        return;
      }
      this.blockUI.start();
      try{
        let fuentes_subidas=0;
        for(let fuente of (datos.fuentes || [])){
          if(this.fuentes_personalizadas.some((f) => f.nombre==fuente.nombre)){
            continue;
          }
          let res:any=await this.certificadosService.guardarFuente({ id_empresa:this.usuario.id_empresa, nombre:fuente.nombre,
                                                                      extension:fuente.extension, archivo:fuente.archivo }).toPromise();
          if(res.tiene_error){
            this.toastr.warning("La fuente "+fuente.nombre+" no se pudo registrar: "+res.mensaje);
            continue;
          }
          this.fuentes_personalizadas.push(res.fuente);
          this.cargarFuenteLienzo(res.fuente);
          fuentes_subidas++;
        }
        let p=datos.plantilla;
        let nombre=p.nombre || "Plantilla importada";
        if(this.plantillas.some((existente) => existente.nombre==nombre)){
          nombre=nombre+" (importada)";
        }
        this.plantilla={ id_campeonato:this.campeonato.id, id_empresa:this.usuario.id_empresa, nombre:nombre,
                         tipo:this.tipos_certificado.some((t) => t.codigo==p.tipo)?p.tipo:"PARTICIPACION",
                         tamano_papel:this.tamanos_papel[p.tamano_papel]?p.tamano_papel:"CARTA",
                         orientacion:p.orientacion=="VERTICAL"?"VERTICAL":"HORIZONTAL",
                         fondo:p.fondo || null, elementos:p.elementos };
        this.elemento=null;
        this.pestana="diseno";
        this.programarVistaPrevia(0);
        this.toastr.success("Plantilla importada"+(fuentes_subidas>0?" (con "+fuentes_subidas+" fuente(s) nueva(s))":"")+
                            ". Revísela y pulse Guardar plantilla para conservarla.");
      }finally{
        this.blockUI.stop();
      }
    };
    lector.readAsText(archivo);
  }

  /* ---------- Vista previa ---------- */

  //espera a que se deje de escribir para no redibujar el PDF en cada tecla
  programarVistaPrevia(espera=600){
    clearTimeout(this.temporizador_vista_previa);
    this.temporizador_vista_previa=setTimeout(() => this.actualizarVistaPrevia(),espera);
  }

  cambiarVista(vista){
    this.vista=vista;
    if(vista=="pdf"){
      this.programarVistaPrevia(0);
    }
  }

  //el PDF solo se dibuja si se esta mirando: en el lienzo cada cambio ya se ve al instante
  async actualizarVistaPrevia(){
    if(!this.plantilla || this.vista!="pdf"){
      return;
    }
    let plantilla=this.plantilla;
    this.vista_previa.generando=true;
    this.vista_previa.mensaje=null;
    try{
      let jugador_equipo=this.jugadorVistaPrevia();
      let blob=await this.generarBlobCertificados(plantilla,[jugador_equipo]);
      if(this.plantilla!==plantilla){
        return; //se cambio de plantilla mientras se dibujaba
      }
      this.vista_previa.pdf=new Uint8Array(await blob.arrayBuffer());
    }catch(error){
      console.error(error);
      this.vista_previa.mensaje="No se pudo dibujar la vista previa: revise las imágenes y los valores del diseño.";
    }finally{
      this.vista_previa.generando=false;
    }
  }

  jugadorVistaPrevia(){
    return this.jugadores_equipo.length>0?this.jugadores_equipo[0]:this.jugadorEjemplo();
  }

  //para que el diseño se pueda ver aunque el campeonato todavia no tenga jugadores
  jugadorEjemplo(){
    return {
      jugador:{ codigo:"J-0001", posicion:"DELANTERO", persona:{ nombre_completo:"Juan Pérez Mamani", ci:"1234567", imagen:null } },
      equipo:{ nombre:"Equipo de ejemplo", logo:null, categoria:{ nombre:"LIBRE" }, disciplina:{ nombre:"FÚTBOL" } }
    };
  }

  /* ---------- Generacion ---------- */

  armarFiltros(){
    let disciplinas=new Map(),categorias=new Map(),equipos=new Map();
    this.jugadores_equipo.forEach((je) => {
      if(je.equipo.disciplina){
        disciplinas.set(je.equipo.disciplina.id,je.equipo.disciplina);
      }
      if(je.equipo.categoria){
        categorias.set(je.equipo.categoria.id,je.equipo.categoria);
      }
      equipos.set(je.equipo.id,je.equipo);
    });
    let porNombre=(a:any,b:any) => a.nombre.localeCompare(b.nombre);
    this.disciplinas=Array.from(disciplinas.values()).sort(porNombre);
    this.categorias=Array.from(categorias.values()).sort(porNombre);
    this.equipos=Array.from(equipos.values()).sort(porNombre);
  }

  //solo las categorias que tienen equipos de la disciplina elegida
  categoriasFiltradas(){
    if(!this.filtro.id_disciplina){
      return this.categorias;
    }
    return this.categorias.filter((c) => this.equipos.some((e) => e.id_categoria==c.id && e.id_disciplina==this.filtro.id_disciplina));
  }

  equiposFiltrados(){
    return this.equipos.filter((e) =>
      (!this.filtro.id_disciplina || e.id_disciplina==this.filtro.id_disciplina) &&
      (!this.filtro.id_categoria || e.id_categoria==this.filtro.id_categoria));
  }

  cambiarDisciplina(){
    //la categoria elegida puede no tener equipos de la disciplina nueva
    if(this.filtro.id_categoria && !this.categoriasFiltradas().some((c) => c.id==this.filtro.id_categoria)){
      this.filtro.id_categoria=null;
    }
    this.cambiarCategoria();
  }

  cambiarCategoria(){
    //el equipo elegido puede no ser de la categoria nueva
    if(this.filtro.id_equipo && !this.equiposFiltrados().some((e) => e.id==this.filtro.id_equipo)){
      this.filtro.id_equipo=null;
    }
  }

  //tipo: TODOS, JUGADORES o MANUALES. Una persona agregada sin equipo solo aparece si no se filtra por equipo,
  //categoria ni disciplina
  jugadoresFiltrados(){
    let texto=(this.filtro.texto || "").toLowerCase();
    let tipo=this.filtro.tipo || "TODOS";
    let lista=(tipo=="MANUALES"?[]:this.jugadores_equipo).concat(tipo=="JUGADORES"?[]:this.destinatarios_manuales);
    return lista.filter((je) =>
      (!this.filtro.id_disciplina || je.equipo.id_disciplina==this.filtro.id_disciplina) &&
      (!this.filtro.id_categoria || je.equipo.id_categoria==this.filtro.id_categoria) &&
      (!this.filtro.id_equipo || je.equipo.id==this.filtro.id_equipo) &&
      (!texto || (je.jugador.persona.nombre_completo || "").toLowerCase().indexOf(texto)>-1));
  }

  /* ---------- Destinatarios manuales ---------- */

  /* Entrenadores, delegados y otras personas que no estan registradas como jugadores. Tienen la misma forma que
     un jugador_equipo (jugador.persona, equipo) para que la plantilla y sus variables funcionen igual, mas el
     cargo para {cargo}. No van a la base de datos: se recuerdan solo en este navegador, por campeonato. */
  cargos=["Entrenador","Asistente técnico","Delegado","Preparador físico","Médico","Árbitro","Organizador"];
  destinatarios_manuales:any[]=[];
  nueva_persona:any={ nombre:"", ci:"", cargo:"Entrenador", cargo_otro:"", id_equipo:null };

  claveDestinatariosManuales(){
    return "certificados-destinatarios-"+this.campeonato.id;
  }

  cargarDestinatariosManuales(){
    try{
      let guardados=JSON.parse(localStorage.getItem(this.claveDestinatariosManuales()) || "[]");
      this.destinatarios_manuales=guardados.map((d) => this.armarDestinatarioManual(d));
    }catch(error){
      this.destinatarios_manuales=[];
    }
  }

  guardarDestinatariosManuales(){
    try{
      localStorage.setItem(this.claveDestinatariosManuales(),JSON.stringify(this.destinatarios_manuales.map((d) => d.datos)));
    }catch(error){
      //sin almacenamiento del navegador solo se pierden al cerrar
    }
  }

  //el equipo se busca en los equipos del campeonato: si ya no esta, la persona queda sin equipo
  armarDestinatarioManual(datos){
    let equipo=this.equipos.filter((e) => e.id==datos.id_equipo)[0];
    return {
      manual:true,
      id:"m"+datos.id,
      datos:datos,
      cargo:datos.cargo,
      seleccionado:true,
      jugador:{ codigo:"", posicion:"", persona:{ nombre_completo:datos.nombre, ci:datos.ci, imagen:null } },
      equipo:equipo || { id:null, nombre:"", logo:null, categoria:null, disciplina:null }
    };
  }

  agregarDestinatarioManual(){
    let p=this.nueva_persona;
    let cargo=p.cargo=="OTRO"?(p.cargo_otro || "").trim():p.cargo;
    if(!(p.nombre || "").trim()){
      this.toastr.error("Debe escribir el nombre de la persona!");
      return;
    }
    if(!cargo){
      this.toastr.error("Debe indicar el cargo de la persona!");
      return;
    }
    let datos={ id:Date.now(), nombre:p.nombre.trim(), ci:(p.ci || "").trim(), cargo:cargo, id_equipo:p.id_equipo };
    this.destinatarios_manuales.push(this.armarDestinatarioManual(datos));
    this.guardarDestinatariosManuales();
    //se mantiene el cargo y el equipo para cargar seguido a varias personas del mismo equipo
    this.nueva_persona=Object.assign({},p,{ nombre:"", ci:"" });
    this.toastr.success(datos.nombre+" agregado como "+cargo);
  }

  quitarDestinatarioManual(destinatario){
    this.destinatarios_manuales=this.destinatarios_manuales.filter((d) => d!==destinatario);
    this.guardarDestinatariosManuales();
  }

  jugadoresSeleccionados(){
    return this.jugadoresFiltrados().filter((je) => je.seleccionado);
  }

  todosSeleccionados(){
    let lista=this.jugadoresFiltrados();
    return lista.length>0 && lista.every((je) => je.seleccionado);
  }

  seleccionarTodos(valor){
    this.jugadoresFiltrados().forEach((je) => je.seleccionado=valor);
  }

  async generarCertificados(){
    let plantilla=this.plantillas.filter((p) => p.id==this.generacion.id_plantilla)[0];
    if(!plantilla){
      this.toastr.error("Debe seleccionar una plantilla guardada!");
      return;
    }
    let seleccionados=this.jugadoresSeleccionados();
    if(seleccionados.length==0){
      this.toastr.error("Debe seleccionar al menos una persona!");
      return;
    }
    this.blockUI.start();
    try{
      let blob=await this.generarBlobCertificados(plantilla,seleccionados);
      window.open(URL.createObjectURL(blob),'_blank','location=no');
    }catch(error){
      console.error(error);
      this.toastr.error("No se pudo generar el PDF de certificados!");
    }finally{
      this.blockUI.stop();
    }
  }

  /* ---------- Dibujo ---------- */

  formatearFecha(fecha){
    if(!fecha){
      return "";
    }
    let f=new Date(fecha);
    return ("0"+f.getDate()).slice(-2)+"/"+("0"+(f.getMonth()+1)).slice(-2)+"/"+f.getFullYear();
  }

  datosCertificado(jugador_equipo){
    let hoy=new Date();
    let persona=jugador_equipo.jugador.persona || {};
    let equipo=jugador_equipo.equipo || {};
    return {
      jugador:persona.nombre_completo || "",
      ci:persona.ci || "",
      codigo_jugador:jugador_equipo.jugador.codigo || "",
      posicion:jugador_equipo.jugador.posicion || "",
      cargo:jugador_equipo.cargo || "Jugador",
      equipo:equipo.nombre || "",
      categoria:equipo.categoria?equipo.categoria.nombre:"",
      disciplina:equipo.disciplina?equipo.disciplina.nombre:"",
      campeonato:this.campeonato.nombre || "",
      empresa:this.usuario.empresa?this.usuario.empresa.nombre:"",
      fecha_inicio:this.formatearFecha(this.campeonato.fecha_inicio),
      fecha_fin:this.formatearFecha(this.campeonato.fecha_fin),
      fecha_emision:this.formatearFecha(hoy),
      fecha_emision_literal:hoy.getDate()+" de "+this.meses[hoy.getMonth()]+" de "+hoy.getFullYear()
    };
  }

  reemplazarVariables(texto,datos){
    return (texto || "").replace(/\{(\w+)\}/g,(coincidencia,nombre) => datos.hasOwnProperty(nombre)?datos[nombre]:coincidencia);
  }

  /* Cada imagen se pide una sola vez y se achica a lo que hace falta para imprimir su caja a ~200 dpi
     (max_puntos*3 pixeles por lado): un logo de 1254px para una caja de 90pt pesaba ~1.9MB dentro del PDF,
     y con los logos de cada equipo y las fotos el archivo crecia sin necesidad. Se guarda en PNG para no
     perder la transparencia de logos y firmas. */
  imagen(ruta,max_puntos){
    if(!ruta){
      return Promise.resolve(null);
    }
    let url=ruta.indexOf("data:")==0?ruta:this.rest_server+ruta;
    let max_pixeles=Math.max(60,Math.round((Number(max_puntos) || 300)*3));
    let clave=max_pixeles+"|"+url;
    if(!this.cache_imagenes.has(clave)){
      this.cache_imagenes.set(clave,this.cargarImagenReducida(url,max_pixeles).catch((error) => {
        console.error(error);
        return null; //una imagen que no carga no impide generar el resto del certificado
      }));
    }
    return this.cache_imagenes.get(clave);
  }

  cargarImagenReducida(url,max_pixeles):Promise<string>{
    return new Promise((resolver,rechazar) => {
      let img=new Image();
      img.crossOrigin="Anonymous";
      img.onload=() => {
        let factor=Math.min(1,max_pixeles/Math.max(img.width,img.height));
        let canvas=document.createElement("canvas");
        canvas.width=Math.max(1,Math.round(img.width*factor));
        canvas.height=Math.max(1,Math.round(img.height*factor));
        let contexto=canvas.getContext("2d");
        contexto.imageSmoothingQuality="high";
        contexto.drawImage(img,0,0,canvas.width,canvas.height);
        resolver(canvas.toDataURL("image/png"));
      };
      img.onerror=() => rechazar("Error loading "+url);
      img.src=url;
    });
  }

  rutaImagenElemento(elemento,jugador_equipo){
    if(elemento.origen=="logo_campeonato"){
      return this.campeonato.logo;
    }else if(elemento.origen=="logo_equipo"){
      return jugador_equipo.equipo?jugador_equipo.equipo.logo:null;
    }else if(elemento.origen=="foto_jugador"){
      return jugador_equipo.jugador.persona?jugador_equipo.jugador.persona.imagen:null;
    }
    return elemento.imagen;
  }

  /* Achica la letra hasta que el texto entre en el alto de su caja y, si aun asi no cabe, lo recorta con
     puntos suspensivos (como en el carnet), asi un nombre largo no se monta sobre el elemento de abajo */
  escribirTexto(doc,elemento,texto,fuentes_registradas:Set<string>){
    let tamano=Number(elemento.tamano) || 12;
    let alto=Number(elemento.alto) || 0;
    let opciones:any={ width:Number(elemento.ancho) || 100, align:elemento.alineacion || "left" };
    //una fuente personalizada que se borro (o no cargo) sale en Helvetica en vez de romper el PDF
    let fuente=elemento.fuente || "Helvetica";
    if(!this.esFuenteEstandar(fuente) && !fuentes_registradas.has(fuente)){
      fuente="Helvetica";
    }
    doc.font(fuente).fontSize(tamano);
    //borde del texto: pdfkit lo dibuja como relleno + trazo (modo 2), con el trazo centrado en el contorno
    //de cada letra, igual que -webkit-text-stroke en el lienzo
    let borde=Number(elemento.borde_grosor) || 0;
    doc.save();
    doc.fillColor(elemento.color || "#000000");
    if(borde>0){
      doc.lineWidth(borde).strokeColor(elemento.borde_color || "#000000").lineJoin("round");
      opciones.fill=true;
      opciones.stroke=true;
    }
    if(Number(elemento.curvatura)){
      this.escribirTextoCurvo(doc,elemento,texto.replace(/\s*\n\s*/g," "),opciones);
      doc.restore();
      return;
    }
    if(alto>0){
      while(tamano>6 && doc.heightOfString(texto,opciones)>alto){
        tamano=tamano-0.5;
        doc.fontSize(tamano);
      }
      opciones.height=alto;
      opciones.ellipsis=true;
    }
    doc.text(texto,Number(elemento.x),Number(elemento.y),opciones);
    doc.restore();
  }

  /* Texto en arco, una linea centrada en la caja. curvatura va de -100 a 100: positiva lo arquea hacia arriba
     (∩), negativa hacia abajo (∪), y 100 cierra casi una vuelta completa. La letra del medio queda con su
     parte de arriba en la y de la caja; cada letra se coloca sobre el arco y se gira segun la tangente.
     El lienzo usa la misma geometria (disposicionTextoCurvo). */
  escribirTextoCurvo(doc,elemento,texto,opciones){
    let letras=Array.from(texto as string);
    let anchos=letras.map((letra) => doc.widthOfString(letra));
    let ascenso=doc._font.ascender/1000*doc._fontSize;
    let posiciones=this.disposicionTextoCurvo(elemento,anchos,ascenso);
    letras.forEach((letra,i) => {
      let p=posiciones[i];
      doc.save();
      doc.translate(p.x,p.y);
      doc.rotate(p.giro);
      doc.text(letra,-anchos[i]/2,-ascenso,{ lineBreak:false, fill:opciones.fill, stroke:opciones.stroke });
      doc.restore();
    });
  }

  //centro de la linea base de cada letra (x, y) y su giro en grados, en puntos de la hoja
  disposicionTextoCurvo(elemento,anchos:number[],ascenso:number){
    let curvatura=Math.max(-100,Math.min(100,Number(elemento.curvatura) || 0));
    let total=anchos.reduce((suma,ancho) => suma+ancho,0);
    let angulo=Math.abs(curvatura)/100*2*Math.PI*0.98;
    let radio=total/angulo;
    let cx=Number(elemento.x)+Number(elemento.ancho)/2;
    let base=Number(elemento.y)+ascenso;
    let hacia_arriba=curvatura>0;
    let centro_y=hacia_arriba?base+radio:base-radio;
    let recorrido=-total/2;
    return anchos.map((ancho) => {
      let s=recorrido+ancho/2;
      recorrido+=ancho;
      let phi=s/radio;
      return hacia_arriba?
        { x:cx+radio*Math.sin(phi), y:centro_y-radio*Math.cos(phi), giro:phi*180/Math.PI }:
        { x:cx+radio*Math.sin(phi), y:centro_y+radio*Math.cos(phi), giro:-phi*180/Math.PI };
    });
  }

  async dibujarCertificado(doc,plantilla,jugador_equipo,W,H,fuentes_registradas:Set<string>){
    let fondo=await this.imagen(plantilla.fondo,Math.max(W,H));
    if(fondo){
      doc.image(fondo,0,0,{ width:W, height:H });
    }
    let datos=this.datosCertificado(jugador_equipo);
    for(let elemento of plantilla.elementos){
      let x=Number(elemento.x),y=Number(elemento.y),ancho=Number(elemento.ancho),alto=Number(elemento.alto);
      if(elemento.tipo=="texto"){
        let texto=this.reemplazarVariables(elemento.contenido,datos);
        this.escribirTexto(doc,elemento,elemento.mayusculas?texto.toUpperCase():texto,fuentes_registradas);
      }else if(elemento.tipo=="imagen"){
        let imagen=await this.imagen(this.rutaImagenElemento(elemento,jugador_equipo),Math.max(ancho,alto));
        if(imagen){
          //el giro es sobre el centro de la caja, como en el lienzo (pdfkit gira en sentido horario, igual que css)
          let rotacion=Number(elemento.rotacion) || 0;
          doc.save();
          if(rotacion){
            doc.rotate(rotacion,{ origin:[x+ancho/2,y+alto/2] });
          }
          doc.image(imagen,x,y,{ fit:[ancho,alto], align:"center", valign:"center" });
          doc.restore();
        }
      }else if(elemento.tipo=="linea"){
        doc.save().moveTo(x,y).lineTo(x+ancho,y).lineWidth(Number(elemento.grosor) || 1)
           .strokeColor(elemento.color || "#000000").stroke().restore();
      }else if(elemento.tipo=="marco"){
        doc.save().rect(x,y,ancho,alto).lineWidth(Number(elemento.grosor) || 1)
           .strokeColor(elemento.color || "#000000").stroke().restore();
      }
    }
  }

  async generarBlobCertificados(plantilla,jugadores_equipo):Promise<Blob>{
    let [W,H]=this.medidasPagina(plantilla);
    let doc=new PDFDocument({ size:[W,H], margin:0, autoFirstPage:true });
    let stream=doc.pipe(blobStream());
    let fuentes_registradas=await this.registrarFuentesPdf(doc,plantilla);
    for(let i=0;i<jugadores_equipo.length;i++){
      if(i>0){
        doc.addPage({ size:[W,H], margin:0 });
      }
      await this.dibujarCertificado(doc,plantilla,jugadores_equipo[i],W,H,fuentes_registradas);
    }
    doc.end();
    return new Promise((resolver) => {
      stream.on('finish',() => resolver(stream.toBlob('application/pdf')));
    });
  }

  /* ---------- Fuentes ---------- */

  esFuenteEstandar(fuente){
    return this.fuentes.indexOf(fuente)>-1;
  }

  //en el lienzo la fuente se usa como familia css 'cert-<nombre>'; en el PDF se registra con su nombre
  cargarFuenteLienzo(fuente){
    let cara=new FontFace("cert-"+fuente.nombre,"url(\""+this.rest_server+fuente.ruta+"\")");
    cara.load().then((cargada) => (document as any).fonts.add(cargada)).catch((error) => console.error(error));
  }

  archivoFuente(fuente):Promise<ArrayBuffer>{
    let url=this.rest_server+fuente.ruta;
    if(!this.cache_fuentes.has(url)){
      this.cache_fuentes.set(url,fetch(url).then((respuesta) => {
        if(!respuesta.ok){
          throw new Error("No se pudo descargar la fuente "+fuente.nombre);
        }
        return respuesta.arrayBuffer();
      }).catch((error) => {
        this.cache_fuentes.delete(url);
        throw error;
      }));
    }
    return this.cache_fuentes.get(url);
  }

  //pdfkit solo conoce las fuentes estandar: las personalizadas que usa la plantilla se registran en cada documento
  async registrarFuentesPdf(doc,plantilla):Promise<Set<string>>{
    let registradas=new Set<string>();
    let usadas=new Set<string>(plantilla.elementos.filter((e) => e.tipo=="texto" && e.fuente && !this.esFuenteEstandar(e.fuente)).map((e) => e.fuente));
    for(let nombre of Array.from(usadas)){
      let fuente=this.fuentes_personalizadas.filter((f) => f.nombre==nombre)[0];
      if(!fuente){
        continue;
      }
      try{
        doc.registerFont(nombre,await this.archivoFuente(fuente));
        registradas.add(nombre);
      }catch(error){
        console.error(error);
      }
    }
    return registradas;
  }

  seleccionarArchivoFuente(evento){
    let archivo=evento.target.files[0];
    if(!archivo){
      return;
    }
    let es_otf=/\.otf$/i.test(archivo.name);
    this.nueva_fuente.extension=es_otf?".otf":".ttf";
    if(!this.nueva_fuente.nombre){
      this.nueva_fuente.nombre=archivo.name.replace(/\.(ttf|otf)$/i,"").replace(/[^A-Za-z0-9_-]/g,"");
    }
    let lector=new FileReader();
    lector.onloadend=() => this.nueva_fuente.archivo=lector.result;
    lector.readAsDataURL(archivo);
  }

  guardarFuente(){
    this.nueva_fuente.nombre=(this.nueva_fuente.nombre || "").replace(/[^A-Za-z0-9_-]/g,"");
    if(!this.nueva_fuente.nombre || !this.nueva_fuente.archivo){
      this.toastr.error("Debe elegir el archivo TTF/OTF y darle un nombre (letras, números y guiones)!");
      return;
    }
    this.blockUI.start();
    this.certificadosService.guardarFuente({ id_empresa:this.usuario.id_empresa, nombre:this.nueva_fuente.nombre,
                                             extension:this.nueva_fuente.extension, archivo:this.nueva_fuente.archivo }).subscribe((res:any) => {
      this.blockUI.stop();
      if(res.tiene_error){
        this.toastr.error(res.mensaje);
        return;
      }
      //si se reemplazo una fuente con el mismo nombre, se vuelve a descargar
      this.fuentes_personalizadas=this.fuentes_personalizadas.filter((f) => f.nombre!=res.fuente.nombre);
      this.cache_fuentes.delete(this.rest_server+res.fuente.ruta);
      this.fuentes_personalizadas.push(res.fuente);
      this.cargarFuenteLienzo(res.fuente);
      this.nueva_fuente={ nombre:"", archivo:null, extension:".ttf" };
      this.toastr.success(res.mensaje);
    });
  }

  abrirPopupConfirmacionEliminacionFuente(fuente){
    let popup=this.modalService.open(PopupConfirmacionComponent);
    popup.componentInstance.message="¿Esta seguro de eliminar la fuente "+fuente.nombre+"? Los textos que la usan saldrán en Helvetica.";
    popup.componentInstance.data=fuente;
    popup.componentInstance.onConfirm.subscribe(($e) => {
      if($e.confirm){
        this.eliminarFuente($e.data);
      }
      popup.close();
    });
  }

  eliminarFuente(fuente){
    this.blockUI.start();
    this.certificadosService.eliminarFuente(this.usuario.id_empresa,fuente.nombre).subscribe((res:any) => {
      this.blockUI.stop();
      this.fuentes_personalizadas=this.fuentes_personalizadas.filter((f) => f.nombre!=fuente.nombre);
      this.cache_fuentes.delete(this.rest_server+fuente.ruta);
      this.toastr.success(res.mensaje);
      this.programarVistaPrevia(0);
    });
  }

  /* ---------- Lienzo ---------- */

  @HostListener('window:resize')
  alCambiarTamanoVentana(){
    this.alto_ventana=window.innerHeight;
  }

  /* La hoja se dibuja a 1px por punto PDF y se escala con transform para que entre entera: a lo ancho de la
     columna y, en pantallas anchas, tambien a lo alto de la ventana (descontando cabecera, pestañas, botones y el texto de ayuda de abajo),
     asi una hoja horizontal se ve completa sin tener que bajar. Con el lienzo ampliado (panel oculto) llena
     todo el ancho aunque haya que bajar, para trabajar los detalles en grande */
  escalaLienzo(){
    let [W,H]=this.medidasPagina(this.plantilla);
    let escala=this.ancho_lienzo>0?this.ancho_lienzo/W:0.5;
    if(window.innerWidth>=992 && !this.panel_oculto){
      escala=Math.min(escala,Math.max(200,this.alto_ventana-295)/H);
    }
    return escala;
  }

  urlImagenLienzo(ruta){
    if(!ruta){
      return null;
    }
    return ruta.indexOf("data:")==0?ruta:this.rest_server+ruta;
  }

  textoLienzo(elemento){
    let texto=this.reemplazarVariables(elemento.contenido,this.datosCertificado(this.jugadorVistaPrevia()));
    return elemento.mayusculas?texto.toUpperCase():texto;
  }

  //equivalente css aproximado de cada fuente estandar de pdfkit; el PDF exacto se ve en la pestaña PDF
  estiloFuente(fuente){
    fuente=fuente || "Helvetica";
    let estilo:any={ "font-weight":/Bold/.test(fuente)?"bold":"normal", "font-style":/Oblique|Italic/.test(fuente)?"italic":"normal" };
    if(!this.esFuenteEstandar(fuente)){
      estilo["font-family"]="'cert-"+fuente+"', Helvetica, Arial, sans-serif";
      estilo["font-weight"]="normal";
      estilo["font-style"]="normal";
    }else if(fuente.indexOf("Times")==0){
      estilo["font-family"]="'Times New Roman', Times, serif";
    }else if(fuente.indexOf("Courier")==0){
      estilo["font-family"]="'Courier New', Courier, monospace";
    }else{
      estilo["font-family"]="Helvetica, Arial, sans-serif";
    }
    return estilo;
  }

  estiloElemento(elemento){
    let x=Number(elemento.x),y=Number(elemento.y),ancho=Number(elemento.ancho),alto=Number(elemento.alto),grosor=Number(elemento.grosor) || 1;
    if(elemento.tipo=="texto"){
      let borde=Number(elemento.borde_grosor) || 0;
      return Object.assign({ left:x+"px", top:y+"px", width:ancho+"px", height:alto>0?alto+"px":"auto",
        "font-size":(Number(elemento.tamano) || 12)+"px", color:elemento.color, "text-align":elemento.alineacion || "left",
        "-webkit-text-stroke":borde>0?borde+"px "+(elemento.borde_color || "#000000"):null },
        this.estiloFuente(elemento.fuente));
    }else if(elemento.tipo=="linea"){
      //la linea es fina: se agarra por una franja de 10px centrada en ella
      return { left:x+"px", top:(y-5)+"px", width:ancho+"px", height:"10px" };
    }else if(elemento.tipo=="marco"){
      //pdfkit dibuja el trazo centrado en el borde del rectangulo
      return { left:(x-grosor/2)+"px", top:(y-grosor/2)+"px", width:(ancho+grosor)+"px", height:(alto+grosor)+"px",
               "border-width":grosor+"px", "border-color":elemento.color };
    }
    //imagen: gira sobre su centro, igual que en el PDF
    return { left:x+"px", top:y+"px", width:ancho+"px", height:alto+"px",
             transform:Number(elemento.rotacion)?"rotate("+Number(elemento.rotacion)+"deg)":null };
  }

  /* Letras del texto curvo en el lienzo, con la misma geometria que el PDF (disposicionTextoCurvo). Los anchos
     y el ascenso se miden con un canvas en la fuente css equivalente. Cada letra es un span de line-height 1:
     su linea base queda a (tamaño-(ascenso+descenso))/2+ascenso de su borde de arriba, y gira sobre ese punto.
     Se guarda por texto/fuente/tamaño/curvatura para no medir en cada ciclo de deteccion de cambios. */
  cache_texto_curvo:Map<string,any[]>=new Map();
  canvas_medicion:HTMLCanvasElement;

  letrasTextoCurvo(elemento){
    let texto=this.textoLienzo(elemento).replace(/\s*\n\s*/g," ");
    let tamano=Number(elemento.tamano) || 12;
    let estilo=this.estiloFuente(elemento.fuente);
    //fonts.size cambia cuando termina de cargar una fuente personalizada: asi se vuelve a medir con ella
    let clave=[texto,elemento.fuente,tamano,elemento.curvatura,elemento.x,elemento.y,elemento.ancho,(document as any).fonts.size].join("|");
    if(this.cache_texto_curvo.has(clave)){
      return this.cache_texto_curvo.get(clave);
    }
    this.canvas_medicion=this.canvas_medicion || document.createElement("canvas");
    let contexto=this.canvas_medicion.getContext("2d");
    contexto.font=estilo["font-style"]+" "+estilo["font-weight"]+" "+tamano+"px "+estilo["font-family"];
    let metrica=contexto.measureText("Hg");
    let ascenso=metrica.fontBoundingBoxAscent || tamano*0.8;
    let descenso=metrica.fontBoundingBoxDescent || tamano*0.2;
    let base_en_span=(tamano-(ascenso+descenso))/2+ascenso;
    let letras:string[]=Array.from(texto as string);
    let anchos=letras.map((letra) => contexto.measureText(letra).width);
    let posiciones=this.disposicionTextoCurvo(elemento,anchos,ascenso);
    let x=Number(elemento.x),y=Number(elemento.y);
    let resultado=letras.map((letra,i) => ({
      letra:letra,
      estilo:{ left:(posiciones[i].x-x-anchos[i]/2)+"px", top:(posiciones[i].y-y-base_en_span)+"px", width:anchos[i]+"px",
               transform:"rotate("+posiciones[i].giro+"deg)", "transform-origin":(anchos[i]/2)+"px "+base_en_span+"px" }
    }));
    if(this.cache_texto_curvo.size>200){
      this.cache_texto_curvo.clear();
    }
    this.cache_texto_curvo.set(clave,resultado);
    return resultado;
  }

  fijarCurvatura(elemento,valor){
    elemento.curvatura=Math.max(-100,Math.min(100,Math.round(Number(valor) || 0)));
    this.programarVistaPrevia();
  }

  fijarGrosorBorde(elemento,valor){
    elemento.borde_grosor=Math.max(0,Math.min(10,Number(valor) || 0));
    this.programarVistaPrevia();
  }

  //deja el giro entre -180 y 180 grados
  normalizarGiro(grados){
    grados=Math.round(Number(grados) || 0)%360;
    if(grados>180){
      grados-=360;
    }else if(grados<=-180){
      grados+=360;
    }
    return grados;
  }

  girarElemento(elemento,grados){
    elemento.rotacion=this.normalizarGiro((Number(elemento.rotacion) || 0)+grados);
    this.programarVistaPrevia();
  }

  estiloLinea(elemento){
    let grosor=Number(elemento.grosor) || 1;
    return { top:(5-grosor/2)+"px", height:grosor+"px", background:elemento.color };
  }

  iniciarArrastre(evento:PointerEvent,elemento,modo){
    evento.stopPropagation();
    evento.preventDefault();
    this.elemento=elemento;
    let lienzo:any=(evento.target as HTMLElement).closest(".cert-lienzo");
    if(lienzo){
      lienzo.focus();
    }
    this.terminarArrastre();
    this.arrastre={ modo:modo, elemento:elemento, px:evento.clientX, py:evento.clientY,
                    x:Number(elemento.x), y:Number(elemento.y), ancho:Number(elemento.ancho), alto:Number(elemento.alto) || 0,
                    rotacion:Number(elemento.rotacion) || 0 };
    if(modo=="girar"){
      //el centro del elemento en pantalla (el de su caja girada es el mismo) es el eje del giro
      let caja=(evento.target as HTMLElement).closest(".cert-el").getBoundingClientRect();
      this.arrastre.cx=caja.left+caja.width/2;
      this.arrastre.cy=caja.top+caja.height/2;
    }
    window.addEventListener("pointermove",this.alMoverArrastre);
    window.addEventListener("pointerup",this.alSoltarArrastre);
  }

  alMoverArrastre=(evento:PointerEvent) => {
    let a=this.arrastre;
    if(!a){
      return;
    }
    let escala=this.escalaLienzo();
    let dx=(evento.clientX-a.px)/escala,dy=(evento.clientY-a.py)/escala;
    let [W,H]=this.medidasPagina(this.plantilla);
    let e=a.elemento;
    if(a.modo=="mover"){
      let x=Math.round(a.x+dx),y=Math.round(a.y+dy);
      //se pega al centro de la hoja si queda a menos de 4 puntos, y se marca con una guia
      this.guias.vertical=Math.abs(x+a.ancho/2-W/2)<=4;
      if(this.guias.vertical){
        x=W/2-a.ancho/2;
      }
      this.guias.horizontal=a.alto>0 && Math.abs(y+a.alto/2-H/2)<=4;
      if(this.guias.horizontal){
        y=H/2-a.alto/2;
      }
      e.x=x;
      e.y=y;
    }else if(a.modo=="girar"){
      //el asa esta arriba del elemento: apuntar hacia arriba es 0 grados. Con Mayus va de 15 en 15 y,
      //sin ella, se pega a 0/90/180/270 si queda a menos de 4 grados
      let grados=Math.atan2(evento.clientY-a.cy,evento.clientX-a.cx)*180/Math.PI+90;
      if(evento.shiftKey){
        grados=Math.round(grados/15)*15;
      }else{
        let recto=Math.round(grados/90)*90;
        if(Math.abs(grados-recto)<4){
          grados=recto;
        }
      }
      e.rotacion=this.normalizarGiro(grados);
    }else{
      //con la imagen girada, el movimiento del raton se lleva a los ejes de la imagen
      let rad=a.rotacion*Math.PI/180;
      let dx_rot=dx*Math.cos(rad)+dy*Math.sin(rad),dy_rot=-dx*Math.sin(rad)+dy*Math.cos(rad);
      e.ancho=Math.max(5,Math.round(a.ancho+dx_rot));
      if(e.tipo!="linea"){
        e.alto=Math.max(5,Math.round(a.alto+dy_rot));
      }
    }
  }

  alSoltarArrastre=() => {
    this.terminarArrastre();
  }

  terminarArrastre(){
    window.removeEventListener("pointermove",this.alMoverArrastre);
    window.removeEventListener("pointerup",this.alSoltarArrastre);
    this.arrastre=null;
    this.guias={ vertical:false, horizontal:false };
  }

  //flechas: mueve 1 punto (con mayuscula 10); Supr quita el elemento
  teclaLienzo(evento:KeyboardEvent){
    if(!this.elemento){
      return;
    }
    let paso=evento.shiftKey?10:1;
    let movimientos:any={ ArrowLeft:[-paso,0], ArrowRight:[paso,0], ArrowUp:[0,-paso], ArrowDown:[0,paso] };
    if(movimientos[evento.key]){
      evento.preventDefault();
      this.elemento.x=Number(this.elemento.x)+movimientos[evento.key][0];
      this.elemento.y=Number(this.elemento.y)+movimientos[evento.key][1];
    }else if(evento.key=="Delete"){
      evento.preventDefault();
      this.eliminarElemento(this.elemento);
    }
  }

  duplicarElemento(elemento){
    let copia=JSON.parse(JSON.stringify(elemento));
    copia.x=Number(copia.x)+10;
    copia.y=Number(copia.y)+10;
    this.plantilla.elementos.splice(this.plantilla.elementos.indexOf(elemento)+1,0,copia);
    this.elemento=copia;
    this.programarVistaPrevia();
  }

  centrarHorizontal(elemento){
    let [W]=this.medidasPagina(this.plantilla);
    elemento.x=W/2-Number(elemento.ancho)/2;
    this.programarVistaPrevia();
  }

  cerrarComponente(){
    this.alTerminar.emit();
  }

}
